import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Input, Dropdown, Button, Modal, Form, Checkbox, Loader, Icon, Table } from 'semantic-ui-react';
import _ from 'lodash';
import { post } from '../../../util/api';
import { JsonInput } from './fields';

// Alan tanımları: kod kataloğu (server lib/liveOptionSchema) + maytap.option_schema. Buradaki kayıtlar DB'ye yazılır,
// path aynıysa koddaki tanımı ezer; "Kod tanımına dön" DB kaydını siler.

const TYPES = ['bool', 'number', 'text', 'textarea', 'enum', 'color', 'strings', 'json', 'code', 'list'];
const SOURCE = { code: ['kod', ''], override: ['düzenlendi', 'accent'], db: ['yeni', 'ok'] };

function FieldModal({ field, tabs, sections, onClose, onSaved }) {
	const [form, setForm] = useState(_.omit(field, ['source']));
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState(null);
	let set = (k, v) => setForm(_.omitBy(_.assign({}, form, { [k]: v }), _.isUndefined));

	async function save(extra) {
		setSaving(true);
		setError(null);
		try {
			let res = await post('/dahi/message/admin/optionSchema/save', { field: _.assign({}, form, extra) });
			if (!res.data.success) throw new Error(res.data.error);
			onSaved(res.data.schema);
		} catch (err) {
			setError(err.message);
		}
		setSaving(false);
	}

	return (
		<Modal open onClose={onClose} size="small">
			<Modal.Header>{field.path ? field.label || field.path : 'Yeni alan'}</Modal.Header>
			<Modal.Content scrolling>
				<Form>
					<Form.Input label="Yol (path)" placeholder="staticOptions.yeni_ozellik" value={form.path || ''} disabled={!!field.path} onChange={(e, d) => set('path', d.value.trim())} />
					<Form.Group widths="equal">
						<Form.Dropdown label="Sekme" selection value={form.tab} options={_.map(tabs, (t) => ({ key: t.key, value: t.key, text: t.label }))} onChange={(e, d) => set('tab', d.value)} />
						<Form.Dropdown
							label="Bölüm"
							selection
							search
							allowAdditions
							value={form.section}
							options={_.map(_.uniq(_.compact(sections.concat([form.section]))), (s) => ({ key: s, value: s, text: s }))}
							onChange={(e, d) => set('section', d.value)}
						/>
						<Form.Dropdown label="Tip" selection value={form.type} options={_.map(TYPES, (t) => ({ key: t, value: t, text: t }))} onChange={(e, d) => set('type', d.value)} />
					</Form.Group>
					<Form.Input label="Etiket" value={form.label || ''} onChange={(e, d) => set('label', d.value || undefined)} />
					<Form.TextArea label="Açıklama" rows={2} value={form.desc || ''} onChange={(e, d) => set('desc', d.value || undefined)} />
					<Form.Field>
						<label>Varsayılan (JSON)</label>
						<JsonInput value={form.default} rows={1} onChange={(v) => set('default', v)} />
					</Form.Field>
					{form.type === 'enum' ? (
						<Form.Field>
							<label>Seçenekler (JSON)</label>
							<JsonInput value={form.options} rows={4} onChange={(v) => set('options', v)} />
							<div className="yta-field-desc">[{'{ "value": "a", "label": "A" }'}]</div>
						</Form.Field>
					) : null}
					{form.type === 'list' ? (
						<Form.Field>
							<label>Sütunlar (JSON)</label>
							<JsonInput value={form.columns} rows={5} onChange={(v) => set('columns', v)} />
							<div className="yta-field-desc">[{'{ "key": "id", "label": "id", "type": "text" }'}]</div>
						</Form.Field>
					) : null}
					{form.type === 'code' ? (
						<Form.Dropdown
							label="Dil"
							selection
							value={form.lang || 'javascript'}
							options={_.map(['javascript', 'css', 'html', 'json'], (l) => ({ key: l, value: l, text: l }))}
							onChange={(e, d) => set('lang', d.value)}
						/>
					) : null}
					<Form.Group inline>
						<Checkbox label="Kod çalıştırır (danger)" checked={!!form.danger} onChange={(e, d) => set('danger', d.checked || undefined)} />
						<Checkbox label="Gizli" checked={!!form.secret} onChange={(e, d) => set('secret', d.checked || undefined)} style={{ marginLeft: 16 }} />
						<Checkbox label="Salt okunur" checked={!!form.readonly} onChange={(e, d) => set('readonly', d.checked || undefined)} style={{ marginLeft: 16 }} />
					</Form.Group>
				</Form>
				{error ? <div className="yta-warn-list" style={{ marginTop: 10 }}>{error}</div> : null}
			</Modal.Content>
			<Modal.Actions>
				{field.path ? <Button basic color="red" floated="left" content="Formlardan gizle" onClick={() => save({ hidden: true })} loading={saving} /> : null}
				<Button basic content="Vazgeç" onClick={onClose} />
				<Button primary content="Kaydet" loading={saving} disabled={!form.path || !form.tab || !form.type || !form.label} onClick={() => save({ hidden: false })} />
			</Modal.Actions>
		</Modal>
	);
}

export default function SchemaPage() {
	const [schema, setSchema] = useState(null);
	const [error, setError] = useState(null);
	const [search, setSearch] = useState('');
	const [tab, setTab] = useState('');
	const [source, setSource] = useState('');
	const [editing, setEditing] = useState(null);

	useEffect(() => {
		post('/dahi/message/admin/optionSchema', {})
			.then((res) => {
				if (!res.data.success) throw new Error(res.data.error);
				setSchema(res.data.schema);
			})
			.catch((err) => setError(err.message));
	}, []);

	async function resetToCode(path) {
		if (!window.confirm(path + ' için DB kaydı silinsin mi?')) return;
		let res = await post('/dahi/message/admin/optionSchema/delete', { path });
		if (res.data.success) setSchema(res.data.schema);
		else setError(res.data.error);
	}

	if (error) return <div className="yta-warn-list">{error}</div>;
	if (!schema) return <Loader active inline="centered" />;

	let q = search.trim().toLowerCase();
	let list = _.filter(schema.fields, (f) => {
		if (tab && f.tab !== tab) return false;
		if (source && f.source !== source) return false;
		return !q || (f.label + ' ' + f.path).toLowerCase().indexOf(q) !== -1;
	});
	let tabLabel = (k) => _.get(_.find(schema.tabs, { key: k }), 'label', k);

	return (
		<div>
			<div className="yta-head">
				<div>
					<h1>Alan Tanımları</h1>
					<div className="yta-head-sub">
						<Link to="/yta/accounts">Hesap Ayarları</Link> · Formlar bu tanımlardan oluşur. Kaydedilen tanım tüm hesaplarda anında görünür.
					</div>
				</div>
				<div className="yta-head-actions">
					<Button primary icon="plus" content="Yeni alan" onClick={() => setEditing({ tab: tab || 'agent', type: 'bool' })} />
				</div>
			</div>
			<div className="yta-toolbar">
				<Input icon="search" placeholder="Alan ara" value={search} onChange={(e, d) => setSearch(d.value)} style={{ width: 300 }} />
				<Dropdown
					selection
					clearable
					placeholder="Tüm sekmeler"
					value={tab}
					options={_.map(schema.tabs, (t) => ({ key: t.key, value: t.key, text: t.label }))}
					onChange={(e, d) => setTab(d.value)}
				/>
				<Dropdown
					selection
					clearable
					placeholder="Tüm kaynaklar"
					value={source}
					options={_.map(SOURCE, (v, k) => ({ key: k, value: k, text: v[0] }))}
					onChange={(e, d) => setSource(d.value)}
				/>
				<div className="grow" />
				<span className="yta-muted">
					{list.length} / {schema.fields.length} alan{schema.hidden.length ? ' · ' + schema.hidden.length + ' gizli' : ''}
				</span>
			</div>
			<Table compact selectable>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>Alan</Table.HeaderCell>
						<Table.HeaderCell>Sekme / bölüm</Table.HeaderCell>
						<Table.HeaderCell>Tip</Table.HeaderCell>
						<Table.HeaderCell>Kaynak</Table.HeaderCell>
						<Table.HeaderCell />
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{_.map(_.take(list, 300), (f) => (
						<Table.Row key={f.path}>
							<Table.Cell>
								<b>{f.label}</b> {f.danger ? <span className="yta-badge danger">kod</span> : null} {f.secret ? <span className="yta-badge warn">gizli</span> : null}
								<div className="yta-field-key">{f.path}</div>
							</Table.Cell>
							<Table.Cell>
								{tabLabel(f.tab)} <span className="yta-muted">/ {f.section}</span>
							</Table.Cell>
							<Table.Cell>
								<span className="yta-badge">{f.type}</span>
							</Table.Cell>
							<Table.Cell>
								<span className={'yta-badge ' + SOURCE[f.source][1]}>{SOURCE[f.source][0]}</span>
							</Table.Cell>
							<Table.Cell collapsing>
								<button className="yta-iconbtn" title="Düzenle" onClick={() => setEditing(f)}>
									<Icon name="pencil" />
								</button>
								{f.source !== 'code' ? (
									<button className="yta-iconbtn" title={f.source === 'db' ? 'Sil' : 'Kod tanımına dön'} onClick={() => resetToCode(f.path)}>
										<Icon name="undo" />
									</button>
								) : null}
							</Table.Cell>
						</Table.Row>
					))}
				</Table.Body>
			</Table>
			{list.length > 300 ? <div className="yta-muted">İlk 300 alan gösteriliyor, aramayı daraltın.</div> : null}
			{editing ? (
				<FieldModal
					field={editing}
					tabs={schema.tabs}
					sections={_.uniq(_.map(_.filter(schema.fields, editing.tab ? { tab: editing.tab } : {}), 'section'))}
					onClose={() => setEditing(null)}
					onSaved={(s) => {
						setSchema(s);
						setEditing(null);
					}}
				/>
			) : null}
		</div>
	);
}
